export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Epic.83359694.gif","height":600,"width":600,"blurWidth":0,"blurHeight":0};